class NazReturningCustomer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const returningState = this.querySelector('[data-returning-state]');
    const firstState = this.querySelector('[data-first-state]');
    const loggedIn = this.dataset.loggedIn === 'true';
    const showFirst = this.dataset.showFirst === 'true';
    const minimumHours = Number(this.dataset.minHours || 6);

    if (loggedIn) {
      this.hidden = false;
      if (firstState) firstState.hidden = true;
      return;
    }

    try {
      const visitKey = 'naz:last-visit:v1';
      const sessionSeenKey = 'naz:session-seen:v1';
      const sessionReturnKey = 'naz:returning-session:v1';
      const now = Date.now();
      let isReturning = sessionStorage.getItem(sessionReturnKey) === '1';

      if (sessionStorage.getItem(sessionSeenKey) !== '1') {
        const previousVisit = Number(localStorage.getItem(visitKey) || 0);
        isReturning = previousVisit > 0 && now - previousVisit >= minimumHours * 60 * 60 * 1000;
        sessionStorage.setItem(sessionSeenKey, '1');
        sessionStorage.setItem(sessionReturnKey, isReturning ? '1' : '0');
        localStorage.setItem(visitKey, String(now));
      }

      if (isReturning) {
        this.hidden = false;
        if (firstState) firstState.hidden = true;
      } else if (showFirst) {
        this.hidden = false;
        if (returningState) returningState.hidden = true;
        if (firstState) firstState.hidden = false;
      }
    } catch (error) {
      if (showFirst) {
        this.hidden = false;
        if (returningState) returningState.hidden = true;
        if (firstState) firstState.hidden = false;
      }
    }
  }
}

class NazCountdown extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const deadline = Date.parse(this.dataset.deadline || '');
    if (!Number.isFinite(deadline)) return;

    const days = this.querySelector('[data-days]');
    const hours = this.querySelector('[data-hours]');
    const minutes = this.querySelector('[data-minutes]');
    const seconds = this.querySelector('[data-seconds]');
    const expired = this.querySelector('[data-expired]');
    const hideWhenExpired = this.dataset.hideExpired === 'true';
    const pad = (value) => String(value).padStart(2, '0');

    const update = () => {
      const remaining = deadline - Date.now();

      if (remaining <= 0) {
        if (this.timer) window.clearInterval(this.timer);
        if (hideWhenExpired) {
          this.hidden = true;
        } else {
          this.hidden = false;
          const timer = this.querySelector('.naz-countdown__timer');
          if (timer) timer.hidden = true;
          if (expired) expired.hidden = false;
        }
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const dayValue = Math.floor(totalSeconds / 86400);
      const hourValue = Math.floor((totalSeconds % 86400) / 3600);
      const minuteValue = Math.floor((totalSeconds % 3600) / 60);
      const secondValue = totalSeconds % 60;

      if (days) days.textContent = pad(dayValue);
      if (hours) hours.textContent = pad(hourValue);
      if (minutes) minutes.textContent = pad(minuteValue);
      if (seconds) seconds.textContent = pad(secondValue);
      this.hidden = false;
    };

    update();
    this.timer = window.setInterval(update, 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }
}

if (!customElements.get('naz-returning-customer')) {
  customElements.define('naz-returning-customer', NazReturningCustomer);
}
if (!customElements.get('naz-countdown')) {
  customElements.define('naz-countdown', NazCountdown);
}
